import React, { useEffect, useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Clock, BookOpen } from 'lucide-react';
import DashboardLayout from '@/components/DashboardLayout';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function History() {
  const { getAuthHeaders } = useAuth();
  const navigate = useNavigate();
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchHistory();
  }, []);

  const fetchHistory = async () => {
    try {
      const response = await axios.get(`${API}/questions/history`, {
        headers: getAuthHeaders()
      });
      setQuestions(response.data);
    } catch (error) {
      toast.error('Failed to load history');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <DashboardLayout>
        <div className="flex items-center justify-center h-64">
          <div className="text-slate-600">Loading history...</div>
        </div>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <div className="space-y-8 fade-in">
        <div data-testid="history-header" className="bg-white rounded-lg border border-slate-200 p-8">
          <h1 className="text-3xl font-bold text-slate-900 mb-2">Question History</h1>
          <p className="text-slate-600">All your previously asked questions</p>
        </div>

        {questions.length === 0 ? (
          <div className="bg-white rounded-lg border border-slate-200 p-12 text-center">
            <BookOpen className="w-12 h-12 text-slate-400 mx-auto mb-4" />
            <p className="text-slate-600">No questions asked yet</p>
          </div>
        ) : (
          <div className="space-y-4">
            {questions.map((question) => (
              <div
                key={question.id}
                data-testid={`history-item-${question.id}`}
                className="bg-white rounded-lg border border-slate-200 p-6 card-hover cursor-pointer"
                onClick={() => navigate('/ask')}
              >
                <div className="flex items-start justify-between mb-3">
                  <div className="flex space-x-2">
                    <span className="marks-badge bg-blue-50 text-blue-700 px-2 py-1 rounded">
                      {question.marks}M
                    </span>
                    <span className="marks-badge bg-slate-100 text-slate-700 px-2 py-1 rounded">
                      {question.subject}
                    </span>
                  </div>
                  <span className="text-sm text-slate-500 flex items-center">
                    <Clock className="w-4 h-4 mr-1" />
                    {new Date(question.created_at).toLocaleDateString()}
                  </span>
                </div>
                <p className="text-slate-900 font-medium mb-2">{question.question_text}</p>
                <p className="text-slate-600 text-sm line-clamp-2">{question.answer}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </DashboardLayout>
  );
}
